<template>
   <div class="page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="selfPage"
            :page-sizes="pageSizes"
            :page-size="selSize"
            :pager-count ="pagers"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
        </el-pagination>
    </div>
</template>

<script>
export default {
  name: 'Page',
  //   *********************************************************************变量
  props: {
    pagers:{
      type: Number||String,
      default: 7,
    },
    pageindex:{
      type: Number||String,
      default: 0,
    },
    pageTotal: {
      type: Number,
      default: 0,
    },
    currentPage: { // 请求的页数（保留）
      type: Number,
      default: 1,
    },
    pageSize: { // 每页的条数（保留）
      type: Number,
      default: 30,
    },
    operateType: { // 操作类型 可选商品页面 最多可选分页20条
      type: String,
      default: ''
    }
  },
  data() {
    return {
      //分页参数
      selfPage: 1,
      selSize: this.pageindex==1?30:30, // 每页展示的条数
      pageSizes: [],
    }
  },
  //  ********************************************************************** 数据监听
  watch: {
    currentPage(val) {
      if(val) {
        this.selfPage = val;
      }
    },
    pageSize(val) {
      if(val) {
        this.selSize = val;
      }
    },
    operateType(val) {
      if(val == '券卡'){
        this.pageSizes = [30];
      }else if(val == 'DeliveryFolder') {
        this.pageSizes = [10, 20, 30, 50, 100, 200]
      } else if(this.pageindex==1){
        this.pageSizes = [20, 30, 50, 100,150];
      } else {
        this.pageSizes = [10, 20, 30, 50, 100]
      }
    }
  },
  //   *********************************************************************方法
  methods: {
    //分页
    handleSizeChange(val) {
      this.selSize = val;
      console.log(`每页 ${val} 条`);
      this.$emit('nowPageParam',val,1);
      this.selfPage = 1;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.$emit('nowPageParam',this.selSize,val);
    },
  },
  mounted(){
    if(this.operateType == '券卡'){
      this.pageSizes = [30];
    }else if(this.operateType == 'DeliveryFolder') {
      this.pageSizes = [10, 20, 30, 50, 100, 200]
    } else if(this.pageindex == 1){
      this.pageSizes = [20, 30, 50, 100,150];
    } else {
      this.pageSizes = [10, 20, 30, 50, 100]
    }
  }
}
</script>

<style scoped>
.page >>> .el-pagination__jump .el-pagination__editor.el-input {width:50px!important;}
.page >>> .el-pager li {margin:0 auto!important;}
</style>



// WEBPACK FOOTER //
// src/components/common/Page.vue